import { IRequestTemplate } from 'legacy/lut/classes/models/onboarding/RequestTemplate'

import { IForm } from 'core-components/classes/models/IForm'

export const mapRequestTemplateFromCrud = (data: IForm): IRequestTemplate => ({
  EntryId: data.EntryId || 0,
  Name: data.Name || '',
  Type: data.Type || '',
  ActionsCount: data.ActionsCount || 0,
  Actual: data.Actual || 0,
  ProcessCount: data.ProcessCount || 0,
  Created: data.Created || '',
  CreatedBy: data.CreatedBy || '',
  Modified: data.Modified || '',
  ModifiedBy: data.ModifiedBy || '',
  Specialization: data.Specialization || null,
  Country: data.Country || '',
  Contract: data.Contract || '',
  CaseOwnerAudience: data.CaseOwnerAudience || '',
  Props: data.Props || '',
  Notification: data.Notification || null,
  UUID: data.UUID || '',
})
